<template>
    <div v-if="credit">
        <h3 class="mb-3">
            <v-btn @click="$router.go(-1)" class="ma-2 mr-4" outlined small tile>
                <v-icon class="mr-2" small>fas fa-arrow-left</v-icon>
                Назад
            </v-btn>
            Кредит № {{ credit.credit_number }}
        </h3>
        <div class="d-flex justify-end ma-n1 flex-wrap">
            <div class="pa-1">
                <download-contract-button :credit_id="id"/>
            </div>
            <div class="pa-1">
                <v-btn @click="rejectDialog = true" color="error" small style="text-transform: capitalize" width="100%">Отменить
                    кредит
                </v-btn>
            </div>
            <div class="pa-1">
                <v-btn @click="showActiveCreditDialogHandler"
                       color="primary"
                       small style="text-transform: capitalize"
                       v-if="parseInt(credit.initial_payment) === 0 && CREDIT_STATUS_INDEX.created.value === credit.status">Активировать кредит
                </v-btn>
            </div>
        </div>
        <v-row>
            <v-col cols="12" md="6">
                <v-card flat height="100%">
                    <div class="px-4 py-4">
                        <h4>Информация о кредите</h4>
                    </div>
                    <v-simple-table dense>
                        <tbody>
                        <tr>
                            <td>Дата создания:</td>
                            <td>{{ credit.created_at |parseDateWithTimeZone }}</td>
                        </tr>
                        <tr>
                            <td>Сумма кредита:</td>
                            <td>
                                <v-chip color="primary" dark label small>
                                    {{ credit.old_amount|money }}
                                </v-chip>
                            </td>
                        </tr>
                        <tr>
                            <td>Сумма первоначального взноса:</td>
                            <td>
                                <v-chip color="secondary" label small>
                                    {{ credit.initial_payment|money }}
                                </v-chip>
                            </td>
                        </tr>
                        <tr>
                            <td>Автопогашения</td>
                            <td>
                                <v-switch
                                        :readonly="switchLoading"
                                        :label="credit.turn_autopayment ? 'Вкл' : 'Вкыл'"
                                        :loading="switchLoading"
                                        @change="changeAutoPayment"
                                        class="ma-0 mb-0 pb-0"
                                        v-model="credit.turn_autopayment"
                                ></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>Срок кредита:</td>
                            <td> {{ credit.period }} мес. ({{ credit.finish_date |parseDate }})</td>
                        </tr>
                        <tr>
                            <td>Тариф:</td>
                            <td>{{ credit.tariff_name }}</td>
                        </tr>
                        <tr>
                            <td>Процент (мес.):</td>
                            <td>{{ credit.percent }}%</td>
                        </tr>
                        <tr>
                            <td>Филиал:</td>
                            <td>{{ credit.mko_name }}</td>
                        </tr>
                        <tr>
                            <td>Имя сотрудника:</td>
                            <td>{{ credit.worker_name }}</td>
                        </tr>
                        <tr v-if="credit.details">
                            <td>Название товара:</td>
                            <td>{{ credit.details }}</td>
                        </tr>
                        <tr v-if="credit.comment">
                            <td>Комментарии:</td>
                            <td>{{ credit.comment }}</td>
                        </tr>
                        <tr v-if="credit.cancel_reason">
                            <td>Причина отмены:</td>
                            <td>{{ credit.cancel_reason }}</td>
                        </tr>
                        <tr>
                            <td>Статус</td>
                            <td>
                                <v-chip color="info" dark label small>
                                    {{ credit.status_name }}
                                </v-chip>
                            </td>
                        </tr>
                        <tr v-if="CREDIT_STATUS_INDEX.created.value !== credit.status">
                            <td>Последнее изменение:</td>
                            <td>{{ credit.updated_at|parseDate }}</td>
                        </tr>
                        <tr v-if="CREDIT_STATUS_INDEX.created.value !== credit.status">
                            <td>Просроченная задолженность:</td>
                            <td>
                                <v-chip :color="credit.current_debt > 0 ? 'pink' : ''" :text-color="credit.current_debt > 0 ? 'white' : ''"
                                        class="ma-2" label
                                        small>
                                    {{ credit.current_debt|money }}
                                </v-chip>
                            </td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>
            </v-col>
            <v-col cols="12" md="6">
                <v-card flat height="100%">
                    <div class="px-4 py-4">
                        <h4>Клиент</h4>
                    </div>

                    <v-row dense>
                        <v-col cols="12" md="8" sm="12">
                            <v-simple-table dense>
                                <tbody>
                                <tr>
                                    <td>Ф.И.О:</td>
                                    <td>{{ credit.first_name }} {{ credit.last_name }} {{ credit.mid_name }}</td>
                                </tr>
                                <tr>
                                    <td>Паспорт:</td>
                                    <td>{{ credit.passport_series }} {{ credit.passport_number }}</td>
                                </tr>
                                <tr>
                                    <td>Пол:</td>
                                    <td>{{ credit.gender |genderParse }}</td>
                                </tr>
                                <tr>
                                    <td>Адрес:</td>
                                    <td>{{ credit.region_name }}, {{ credit.district_name }}</td>
                                </tr>
                                <tr>
                                    <td>Адрес проживание:</td>
                                    <td>{{ credit.live_address }} {{ credit.address_mfy ? ' МФЙ:' + credit.address_mfy : '' }}</td>
                                </tr>
                                <tr>
                                    <td>ИНН/ПИНФЛ:</td>
                                    <td>{{ credit.inn }}/{{ credit.pnfl }}</td>
                                </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                        <v-col cols="12" md="4" sm="4">
                            <div class="passport-photo">
                                <img :src="'https://api.icangroup.uz/storage/' + credit.passport_photo" class="passport-photo-img"
                                     v-if="credit.passport_photo">
                                <img alt="Нет фотографии" class="passport-photo-img" src="../../../assets/images/no-passport-photo.jpg"
                                     v-else>
                            </div>
                        </v-col>
                    </v-row>
                    <v-simple-table dense>
                        <tbody>
                        <tr>
                            <td>Телефон:</td>
                            <td>
                                <span>{{ credit.phone }}</span>
                                <span v-if="credit.phones && typeof credit.phones === 'string'">,
                  {{ JSON.parse(credit.phones).join('; ') }}
                </span>
                                <v-btn @click="changePhoneDialog = true" class="ml-2" icon small>
                                    <v-icon small>fas fa-edit</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                        <tr>
                            <td>Место работы:</td>
                            <td>{{ credit.work_place }}</td>
                        </tr>
                        <tr>
                            <td>Должность:</td>
                            <td>{{ credit.position }}</td>
                        </tr>
                        <tr>
                            <td>Оценка клиента:</td>
                            <td>{{ credit.user_ball }}</td>
                        </tr>
                        <tr>
                            <td>Пользователь в черном списке:</td>
                            <td>
                                <v-chip :color="credit.has_black_list ? 'error' : 'success'" label small>
                                    {{ credit.has_black_list ? 'Да' : 'Нет' }}
                                </v-chip>
                            </td>
                        </tr>
                        <tr
                                :class="{'font-weight-bold': credit.user_card_id === card.id}"
                                :key="`user-card-${index}`"
                                v-for="(card, index) in credit.user.user_cards"
                        >
                            <td>
                                <v-icon class="mr-2" color="primary" small>fas fa-credit-card</v-icon>
                                {{ card.pan }} -
                                <span class="logo-img-width">
                                    <img v-if="card.service === 'paymo'" src="@/assets/images/paymo.png" :alt="card.service"/>
                                    <img v-if="card.service === 'myuzcard'" src="@/assets/images/myuzcard.png" :alt="card.service"/>
                                </span>
                            </td>
                            <td>
                                {{ card.full_name }} ({{ card.phone }})
                            </td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                    <div class="px-4 py-4">
                        <v-btn @click="createCardDialog = true" color="primary">Добавить карту</v-btn>
                        <v-btn @click="ratingDialog = true" class="ml-3" color="primary"
                               v-if="credit.status === CREDIT_STATUS_INDEX.done.value && !credit.user_ball">Оценить клиент
                        </v-btn>
                        <v-btn @click="addToBlacklistDialog = true" class="ml-3" v-if="!credit.has_black_list">Добавить в черный
                            список
                        </v-btn>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" v-if="graphs.length">
                <v-card flat>
                    <div class="pa-4">
                        <div class="d-flex justify-space-between">
                            <h4>График погашения</h4>
                            <print-graph :credit_id="id"/>
                        </div>
                        <v-simple-table>
                            <thead>
                            <tr>
                                <th>Месяц</th>
                                <th>Основная сумма</th>
                                <th>Процент ({{ credit.percent }}%)</th>
                                <th><b>Уплачено</b></th>
                                <th>Основной (долг)</th>
                                <th>Процент (долг)</th>
                                <th>Общее (долг)</th>
                                <th>Статус</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr :key="`graph-${graph.id}`"
                                class="graphs-table"
                                v-for="graph in graphs">
                                <td>{{ graph.payment_date || parseDate }}</td>
                                <td>{{ graph.main_must_be_paid|money }}</td>
                                <td>{{ graph.percent_must_be_paid|money }}</td>
                                <td><b>{{ graph.paid|money }}</b></td>
                                <td>{{ graph.main_residue|money }}</td>
                                <td>{{ graph.percent_residue|money }}</td>
                                <td>
                                    <v-chip :color="getColor(graph)" class="ma-2" label small>
                                        {{ (Math.ceil(parseFloat(graph.percent_residue) + parseFloat(graph.main_residue)))|money }}
                                    </v-chip>
                                </td>
                                <td>
                                    <v-sheet :color="parseGraphStatus(graph.status).color" class="rounded d-inline-block px-2 " dark>
                                        {{ parseGraphStatus(graph.status).text }}
                                    </v-sheet>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <b>Всего:</b>
                                </td>
                                <td>
                                    <b>{{ (Math.ceil(graphTotal.main_must_be_paid))|money }}</b>
                                </td>
                                <td>
                                    <b>{{ (Math.ceil(graphTotal.percent_must_be_paid))|money }}</b>
                                </td>
                                <td>
                                    <b>{{ (Math.ceil(graphTotal.paid))|money }}</b>
                                </td>
                                <td>
                                    <b>{{ (Math.ceil(graphTotal.main_residue))|money }}</b>
                                </td>
                                <td>
                                    <b>{{ (Math.ceil(graphTotal.percent_residue))|money }}</b>
                                </td>

                                <td>
                                    <b>{{ (Math.ceil(graphTotal.total_debt))|money }}</b>
                                </td>
                            </tr>
                            </tbody>
                        </v-simple-table>
                        <div class="d-flex flex-wrap mx-n2 justify-end"
                             v-if="credit.status !== CREDIT_STATUS_INDEX.cancelled.value">
                            <div class="pa-2">
                                <v-btn @click="$refs.transferCredit.show()" color="primary">Принять оплату</v-btn>
                            </div>
                            <div class="pa-2" v-if="credit.status === CREDIT_STATUS_INDEX.activated.value">
                                <v-btn @click="$refs.closeCreditDialog.show()" color="info">Закрыть кредит</v-btn>
                            </div>
                            <div class="pa-2">
                                <v-btn @click="invoiceDialog = true" color="success">Выставить счет</v-btn>
                            </div>

                        </div>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12">
                <v-card class="pb-4">
                    <div class="pa-4">
                        <h4>История заявок и кредитов</h4>
                    </div>
                    <v-tabs style="box-shadow: none" v-model="step">
                        <div class="d-flex px-4 mx-n3">
                            <div @click="step = STEPS.repaymentHistory" class="px-3">
                                <h5 :class="['cursor-pointer',{'dark-text': step !== STEPS.repaymentHistory}]">История
                                    погашения</h5></div>
                            <div @click="step = STEPS.historyCredit" class="px-3">
                                <h5 :class="['cursor-pointer',{'dark-text': step !== STEPS.historyCredit}]">История кредитов</h5>
                            </div>
                        </div>
                        <v-tabs-items v-model="step">
                            <v-tab-item :value="STEPS.repaymentHistory">
                                <history-transfer-table
                                        :creditId="id"
                                        ref="transferHistoryTable"
                                ></history-transfer-table>
                            </v-tab-item>
                            <v-tab-item :value="STEPS.historyCredit">
                                <history-credit
                                        :creditId="id"
                                        ref="creditHistoryTable"/>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-tabs>
                </v-card>
            </v-col>
        </v-row>
        <create-card-dialog
                :is-card-type-uzcard="!!credit['has_my_uzcard']"
                :mko_id="credit.mko_id" :user_id="credit && credit.user_id" @save="onAddCard"
                v-model="createCardDialog"/>
        <reject-credit-dialog @submit="rejectCredit" v-model="rejectDialog"/>
        <add-to-black-list-dialog @submit="addToBlackList" v-model="addToBlacklistDialog"/>
        <confirm-credit-dialog
                :confirm-message="confirmCreditMessage"
                :credit_id="id"
                :phone="phoneShort" :re-send="showActiveCreditDialogHandler" @confirmed="onConfirmed" ref="confirmDialog"
                v-model="confirmDialog"/>
        <transfer-credit :all-amount="allAmount" :credit_id="id" :user_id="credit.user_id" @transfer="onTransfer"
                         ref="transferCredit"/>
        <v-dialog v-model="invoiceDialog" width="450">
            <v-card>
                <div class="px-6 py-4">
                    <h4>Выставить счет</h4>
                </div>
                <v-card-text>
                    <v-sheet class="rounded pa-2 d-flex" color="primary" dark>
                        <v-icon class="mr-2 " color="#fff" small>fas fa-info-circle</v-icon>
                        <span class="text--lighten-1">На текущий момент у клиента нет задолженности.</span>
                    </v-sheet>

                    <div class="py-2 title">
                        <h5>Номер телефона</h5>
                    </div>
                    <validation-observer v-slot="{handleSubmit}">
                        <form @submit.prevent="handleSubmit(sendNotification)">
                            <custom-input-text
                                    disabled=""
                                    prefix="+998"
                                    v-model="phoneShort"
                            ></custom-input-text>
                            <span>* На указанный номер будет отправлено SMS-сообщение с напоминаем о необходимости оплаты рассрочки</span>
                            <v-btn class="mt-3" color="primary" type="submit" width="100%">Отправить SMS</v-btn>
                        </form>
                    </validation-observer>
                </v-card-text>
            </v-card>
        </v-dialog>
        <rating-dialog
                :credit_id="id"
                @rated="ball => credit.user_ball = ball"
                v-model="ratingDialog"
        />
        <close-credit-dialog
                :credit_id="id"
                @saved="init"
                ref="closeCreditDialog"
        />
        <change-phone-dialog :id="id" :phone="credit.phone" :phones="credit.phones" @save="getCredit" v-model="changePhoneDialog"/>
    </div>
</template>

<script>
	import CreateCardDialog from "@/components/card/CreateCardDialog";
	import {CREDIT_STATUS_INDEX, GRAPH_STATUS, messages, parsePhone, PAYMENT_TYPES} from '@/utils/constants'
	import RejectCreditDialog from "@/components/credit/RejectCreditDialog";
	import ConfirmCreditDialog from "@/components/credit/ConfirmCreditDialog";
	import HistoryTransferTable from "@/components/credit/HistoryTransferTable";
	import TransferCredit from "@/components/credit/TransferCredit";
	import HistoryCredit from "@/components/credit/HistoryCredit";
	import RatingDialog from "@/components/credit/RatingDialog";
	import DownloadContractButton from "@/components/credit/ContractDocument";
	import CloseCreditDialog from "@/components/credit/CloseCreditDialog";
	import PrintGraph from "../../../components/credit/PrintGraph";
	import AddToBlackListDialog from "../../../components/credit/AddToBlackListDialog";
	import ChangePhoneDialog from "../../../components/credit/ChangePhoneDialog";

	const STEPS = {
		repaymentHistory: 0,
		repaymentSchedule: 1,
		historyCredit: 2
	}
	export default {
		components: {
			ChangePhoneDialog,
			AddToBlackListDialog,
			PrintGraph,
			CloseCreditDialog,
			DownloadContractButton,
			RatingDialog,
			HistoryCredit,
			TransferCredit,
			HistoryTransferTable, ConfirmCreditDialog, RejectCreditDialog, CreateCardDialog
		},
		props: ['id'],
		data() {
			return {
				ratingDialog: false,
				confirmCreditMessage: null,
				step: STEPS.repaymentHistory,
				credit: null,
				createCardDialog: false,
				invoiceDialog: false,
				graphs: [],
				phoneShort: null,
				STEPS,
				CREDIT_STATUS_INDEX,
				confirmDialog: false,
				rejectDialog: false,
				addToBlacklistDialog: false,
				changePhoneDialog: false,
				PAYMENT_TYPES,
				allAmount: 0,
				switchLoading: false
			}
		},
		watch: {
			id() {
				const {creditHistoryTable, transferHistoryTable} = this.$refs
				if (creditHistoryTable) creditHistoryTable.reInit()
				if (transferHistoryTable) transferHistoryTable.reInit()
				this.credit = null
				this.graphs = []
				this.init()
			}
		},
		methods: {
			async onAddCard({card_id}) {
				try {
					await this.$http.post('admin/users/add-credit-card', {card_id, credit_id: this.id})
				} catch (e) {
					this.$setResponseError({error: e})
				} finally {
					await this.init()
				}
			},
			async init() {
				this.$showLoading()
				await this.getCredit()
				await this.getGraphs()
				await this.getAllAmount()
				this.$clearLoading()
			},
			async getAllAmount() {
				try {
					const {data: {data}} = await this.$http.get(`admin/credit/debt/${this.id}`)
					this.allAmount = data
				} catch (e) {
					this.$setResponseError({error: e})
				}
			},
			async onConfirmed() {
				const {confirmDialog} = this.$refs
				if (confirmDialog) confirmDialog.clearTime()
				this.confirmCreditMessage = null
				await this.getCredit()
				await this.getGraphs()
				this.confirmDialog = false
			},

			async getCredit() {
				try {
					const {data: {data}} = await this.$http.get(`admin/credits/${this.id}`)
					this.credit = data
					this.phoneShort = parsePhone(data.user_phone).format('min')
				} catch (e) {
					this.$setResponseError({error: e})
				}
			},
			async getGraphs() {
				try {
					const {data: {data}} = await this.$http.get(`admin/credits/auto-payment/${this.id}`)
					this.graphs = data.sort((a, b) => {
						return new Date(a.payment_date).getTime() - new Date(b.payment_date).getTime()
					})
				} catch (e) {
					this.$setResponseError({error: e})
				}
			},
			async showActiveCreditDialogHandler() {
				this.$showLoading()
				try {
					const {data: {data: {message}}} = await this.$http.post(`admin/credits/create/activate/${this.id}`)
					this.$setSuccess({text: messages['onConfirmedCredit']})
					this.onConfirmed();
					this.$clearLoading()
				} catch (e) {
					this.$setResponseError({error: e})
					this.$clearLoading()
				}
			},
			parseGraphStatus(val) {
				const status = GRAPH_STATUS.find(item => item.value === val)
				if (!status) return ''
				return {
					text: status.text,
					color: status.color
				}
			},
			async rejectCredit(comment) {
				this.$showLoading()
				try {
					await this.$http.post(`admin/credits/create/cancel/${this.id}`, {
						comment
					})
					this.rejectDialog = false
					this.$setSuccess({text: messages.onRejectedCredit})
					await this.$router.push({name: 'credit-index'})
				} catch (e) {
					this.$setResponseError({error: e})
				} finally {
					this.$clearLoading()
				}
			},
			async onTransfer() {
				const {transferHistoryTable} = this.$refs
				this.$showLoading()
				await this.getGraphs()
				await this.getCredit()
				if (transferHistoryTable) transferHistoryTable.reInit()
				await this.getAllAmount()
				this.$clearLoading()
			},
			async sendNotification() {
				this.$showLoading()
				try {
					await this.$http.get(`admin/credit/send-notification/${this.id}`)
					this.invoiceDialog = false
					this.$setSuccess({text: messages.sendNotification})
				} catch (e) {
					this.$setResponseError({error: e})
				} finally {
					this.$clearLoading()
				}
			},
			getColor(graph) {
				const debt = parseFloat(graph.percent_residue) + parseFloat(graph.main_residue);
				if (debt < 0) return 'pink';
				else if (debt > 0) return '';
				else return 'success'
			},
			async addToBlackList(comment) {
				this.$showLoading()
				try {
					await this.$http.post(`admin/credit/add-to-blacklist/${this.id}`, {comment})
					this.addToBlacklistDialog = false
					this.credit.has_black_list = true;
					this.$setSuccess({text: messages.sendNotification})
				} catch (e) {
					this.$setResponseError({error: e})
				} finally {
					this.$clearLoading()
				}
			},
			async changeAutoPayment() {
				try {
					this.switchLoading = true;
					const data = await this.$http.post(`admin/credit/change-autopayment/${this.id}`);
					if (data)
						this.switchLoading = false;
				} catch (e) {
					this.switchLoading = false;
					this.$setResponseError({error: e})
				}

			}

		},
		computed: {
			graphTotal() {
				return this.graphs.reduce((info, item) => {
					if (item.main_residue) {
						info.main_residue += parseFloat(item.main_residue)
					}
					if (item.percent_must_be_paid) {
						info.percent_must_be_paid += parseFloat(item.percent_must_be_paid)
					}
					if (item.main_must_be_paid) {
						info.main_must_be_paid += parseFloat(item.main_must_be_paid)
					}

					if (item.main_residue) {
						info.total_debt += parseFloat(item.main_residue) + parseFloat(item.percent_residue)
					}
					if (item.paid) {
						info.paid += parseFloat(item.paid)
					}

					if (item.percent_residue) {
						info.percent_residue += parseFloat(item.percent_residue)
					}
					return info
				}, {
					main_must_be_paid: 0,
					percent_must_be_paid: 0,
					main_residue: 0,
					total_debt: 0,
					percent_residue: 0,
					paid: 0
				})
			}
		},
		created() {
			this.init()
		}
	}
</script>
<style>
    .passport-photo {
        width: 210px;
        height: 210px;
        border: solid #999 1px;
    }

    .passport-photo-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    .logo-img-width img {
        max-width: 50px;
    }
</style>
